<template>
  <v-row
    v-if="!!internalReferences && !!internalReferences.length"
    class="ma-0 pa-0"
  >
    <v-slide-group
      class="ml-2 mb-5"
      :show-arrows="!$vuetify.breakpoint.xsOnly && !_isCordovaApp()"
    >
      <v-slide-item
        v-for="reference in internalReferencesComputed"
        :key="reference.name"
      >
        <v-card
          @click="openReferenceCard(reference)"
          height="70px"
          width="200px"
          class="vetalfa-pointer ma-0 my-2 pa-2 mr-2 vetalfa-card-border-item"
          outlined
        >
          <v-row aling="center" class="ma-0 pa-0 vetalfa-row">
            <v-col class="ma-0 pa-0" cols="2">
              <v-icon
                v-if="!!getIconForRef(reference)"
                size="20"
                color="primary"
                >{{ _icon(getIconForRef(reference)) }}</v-icon
              >
              <v-img
                v-if="!!getImageForRef(reference)"
                contain
                :src="getImageForRef(reference)"
                height="20"
                max-width="20"
              ></v-img>
            </v-col>
            <v-col class="ma-0 pa-0" cols="9">
              <p v-bind:class="getCarouselItemClass(reference)">
                {{ reference.name }}
              </p>
              <p class="ma-0 pa-0 items-description-label">
                {{ reference.category }}
              </p>
            </v-col>
            <v-col class="ma-0 pa-0" cols="1">
              <v-row justify="end" align="center" class="ma-0 pa-0 vetalfa-row">
                <v-icon x-small color="#747678">{{ mdiChevronRight }}</v-icon>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-slide-item>
      <v-slide-item>
        <div style="height: 70px; width: 30px"></div>
      </v-slide-item>
    </v-slide-group>
  </v-row>
</template>

<script>
import sectionsEnum from "@/constants/sections.enum.js";
import { mdiChevronRight } from "@mdi/js";
import { mapActions } from "vuex";
export default {
  name: "InternalReferences",
  props: {
    internalReferences: { default: [], required: true },
  },
  computed: {
    internalReferencesComputed() {
      const map = new Map();
      for (const obj of this.internalReferences) {
        const objectId = obj.name;
        if (!map.has(objectId)) {
          map.set(objectId, obj);
        }
      }
      return this._shuffle(Array.from(map.values()));
    },
  },
  methods: {
    ...mapActions("general", ["routePathRedirect", "logEvent"]),
    openReferenceCard(reference) {
      this.logEvent("openCarouselReference");
      this.routePathRedirect({
        path: reference.path,
        from: { ...this.$route },
      });
    },
    getIconForRef(reference) {
      return sectionsEnum.sections.find((s) => {
        return (
          s.name.replace("e Escores", "").replace("Interativos", "").trim() ===
            reference.category
              .replace("Nutracêuticos", "")
              .replace("| Doses", "")
              .trim() ||
          reference.category.trim().toLowerCase().includes(s.keyword)
        );
      }).icon;
    },
    getImageForRef(reference) {
      return sectionsEnum.sections.find((s) => {
        return (
          s.name.replace("e Escores", "").replace("Interativos", "").trim() ===
            reference.category
              .replace("Nutracêuticos", "")
              .replace("| Doses", "")
              .trim() ||
          reference.category.trim().toLowerCase().includes(s.keyword)
        );
      }).image;
    },
    getCarouselItemClass(reference) {
      return (
        (!!reference.description &&
        !reference.category.includes("Algoritmos") &&
        reference.description.trim() !=
          this._getLabel("ACTIVE_PRINCIPLE_SINGULAR") &&
        !reference.category.includes(this._getLabel("CALCULATORS"))
          ? "items-products-title"
          : "items-title") + " ma-0 pa-0 items-two-lines-clamp"
      );
    },
  },
  data() {
    return {
      mdiChevronRight,
    };
  },
};
</script>
